import { render, staticRenderFns } from "./ClientCompletedPage.vue?vue&type=template&id=6369a498&scoped=true&"
import script from "./ClientCompletedPage.vue?vue&type=script&lang=js&"
export * from "./ClientCompletedPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientCompletedPage.vue?vue&type=style&index=0&id=6369a498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369a498",
  null
  
)

export default component.exports